export const getIndex = (element: Element, parents?: NodeListOf<Element> | Element[] | string): number => {
  const elements = typeof parents === 'string' ? document.querySelectorAll(parents) : parents;
  // 获取所有同级元素
  const children = Array.from(elements ?? element.parentElement!.children);
  // 找到指定元素的索引
  return children.indexOf(element);
}
